<template>
  <div class="employee">
    <CCard class="card-table-emloyee card-overview">
      <CRow class="row-title">
        <div class="title-overview team-player-title"> {{$t("summer_trip.label_team_player")}}</div>
      </CRow>
      <a-row :gutter="[16,8]" class="mx-0 mt-2">
        <a-col :span="6" v-for="item in team_groups" :key="item.key">
          <div class="team-player">
            <div class="team-player-number pt-2 pb-2">{{item.name}} ({{numberOfTeam(item.code)}} {{$t("summer_trip.label_people")}})</div>
            <div class="team-line"></div>
            <div class="team-player-content">
              <div class="pt-1">{{$t("summer_trip.label_team_leader")}}: {{ item.info ? item.info.leader : "" }}</div>
              <div>{{item.info ? item.info.phone : ""}}</div>
            </div>
          </div>
        </a-col>
      </a-row>

      <CRow class="row-title mt-3">
        <div class="title-overview car-title">{{$t("summer_trip.label_shuttle_car_")}}</div>
      </CRow>
      <a-row :gutter="[16,8]" class="mx-0 mt-2">
          <a-col :span="4" v-for="item in car_groups" :key="item.key">
          <div class="team-player">
            <div class="number-car pt-2 pb-2">{{item.name}}</div>
            <div class="card-line"></div>
            <div class="number-people-car">
              <div class="pt-3">{{numberOfCar(item.code)}}  {{$t("summer_trip.label_people")}}</div>
            </div>
          </div>
          </a-col>
        </a-row>
      <CRow class="row-title mt-3">
        <div class="title-overview car-title">{{$t("summer_trip.label_team_ply")}}</div>
      </CRow>
      <a-row :gutter="[16,8]" class="mx-0 mt-2">
          <a-col :span="4" v-for="item in flight_groups" :key="item.key">
          <div class="team-player">
            <div class="number-car pt-2 pb-2">{{item.name}}</div>
            <div class="card-line"></div>
            <div class="number-people-car">
              <div class="pt-3">{{numberOfFlight(item.code)}} {{$t("summer_trip.label_people")}}</div>
            </div>
          </div>
          </a-col>
        </a-row>
    </CCard>
    <CCard class="card-table-emloyee">
      <CRow>
        <CCol sm="2">
          <div class="form-group">
            <label>{{
              $t("summer_trip.label_employee")
            }}</label>
            <CInput
              v-model="searchData.name"
              :placeholder="
                this.$t('summer_trip.label_employee')
              "
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>{{
              $t("summer_trip.label_team")
            }}</label>
            <select
              class="form-control"
              v-model="searchData.team"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option v-for="(team, index) in team_groups" :key="index" :value="team.code">{{ team.name }} ({{ team.color }})</option>
            </select>
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>{{
              $t("summer_trip.car_group")
            }}</label>
            <select
              class="form-control"
              v-model="searchData.car"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option v-for="(car, index) in car_groups" :key="index" :value="car.code">{{ car.name }} ({{ car.color }})</option>
            </select>
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>{{
              $t("summer_trip.flight_group")
            }}<span @click="showModal">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 margin-left-4 help" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" width="16">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </span>
              </label>
            <div>
              <select
                class="form-control"
                v-model="searchData.flight"
                @change="search"
              >
                <option value="0">
                  {{ $t("placeholder.label_employee_option_search") }}
                </option>
                <option v-for="(flight, index) in flight_groups" :key="index" :value="flight.code">{{ flight.name }}</option>
              </select>
            </div>
          </div>
        </CCol>
        <CCol sm="2">
          <div class="form-group">
            <label>Bàn tiệc<span @click="showModal">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 margin-left-4 help" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" width="16">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </span>
              </label>
            <div>
              <select
                class="form-control"
                v-model="searchData.eatting_table"
                @change="search()"
              >
                <option value="0">
                  {{ $t("placeholder.label_employee_option_search") }}
                </option>
                <option v-for="(table, index) in eatting_tables" :key="index" :value="table.eatting_table">{{ table.eatting_table ? table.eatting_table : "Chưa có bàn" }}</option>
              </select>
            </div>
          </div>
        </CCol>
        <CCol sm="8">
          <div class="form-group">
            <label>{{ $t("summer_trip.label_company") }}</label>
            <div class="checkbox-group">
              <a-checkbox-group :value="searchData.company" :options="companiesOptions" @change="(company) => updateField('company', company)"/>
            </div>
          </div>
        </CCol>
        <CCol sm="4">
          <div class="form-group">
            <label>{{ $t("summer_trip.label_target") }}</label>
            <div class="checkbox-group">
              <a-checkbox-group :value="searchData.relative" :options="relativeOptions" @change="showGuest" />
            </div>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" class="text-center btn-search">
          <CButton class="btn-search-employee" @click.prevent="search">{{
            $t("button.label_employee_btn_search")
          }}</CButton>
          <CButton class="btn-reset" @click="resetForm">{{
            $t("button.label_action_reset")
          }}</CButton>
        </CCol>
      </CRow>
    </CCard>
    <CRow>
      <CCol sm="12">
        <div class="total-employee-summer-trip"> {{ $t("summer_trip.label_total_participants") }}: {{total_participants}}</div>
      </CCol>
      <CCol sm="12">
        <CCard class="employee-table">
          <CCardBody class="no-padding">
            <div class="table-responsive">
              <table class="table table-mobile">
                <thead>
                  <tr>
                    <th scope="col" class="cl-pointer"
                      @click="sortByColumn(columnSortArr.id)"
                      >
                      {{ $t("summer_trip.label_summer_trip_employee_code") }}
                       <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('company_trip_employees.employee_id')"
                        ></CIcon>
                       </span>
                    </th>
                    <th scope="col" class="cl-pointer"
                      @click="sortByColumn(columnSortArr.name)"
                      >
                      {{ $t("summer_trip.label_summer_trip_employee_name") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('company_trip_employees.name')"
                        ></CIcon>
                       </span>
                    </th>
                    <th scope="col" class="cl-pointer"
                      @click="sortByColumn(columnSortArr.company_name)"
                    >
                      {{ $t("summer_trip.label_company") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('companies.name')"
                        ></CIcon>
                       </span>
                    </th>
                    <th scope="col" class="cl-pointer"
                      @click="sortByColumn(columnSortArr.departments)"
                    >
                      {{ $t("summer_trip.label_division") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('departments.name')"
                        ></CIcon>
                       </span>
                    </th>
                    <th scope="col">
                      {{ $t("summer_trip.label_job_title") }}
                    </th>
                    <th scope="col">
                      {{ $t("summer_trip.label_guest_name") }}
                    </th>
                    <th scope="col">
                      {{ $t("summer_trip.relationship") }}
                    </th>
                    <th scope="col">
                      {{ $t("summer_trip.label_guest_birthday") }}
                    </th>
                    <th scope="col" class="cl-pointer"
                      @click="sortByColumn(columnSortArr.group)"
                    >
                      {{ $t("summer_trip.label_team") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('lucky_wheel_results.group')"
                        ></CIcon>
                       </span>
                    </th>
                    <th scope="col" class="cl-pointer"
                      @click="sortByColumn(columnSortArr.group_car)"
                    >
                      {{ $t("summer_trip.label_car_come") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('company_trip_employees.car_code')"
                        ></CIcon>
                       </span>
                    </th>
                    <th scope="col" class="cl-pointer"
                      @click="sortByColumn(columnSortArr.group_car_1)"
                    >
                      {{ $t("summer_trip.label_car_back") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('company_trip_employees.car_code_1')"
                        ></CIcon>
                       </span>
                    </th>
                    <th scope="col" class="cl-pointer"
                      @click="sortByColumn(columnSortArr.flight_group)"
                    >
                      {{ $t("summer_trip.label_flight_group") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('company_trip_employees.flight_group')"
                        ></CIcon>
                       </span>
                    </th>
                    <th scope="col"
                      class="cl-pointer"
                      @click="sortByColumn(columnSortArr.hotel_room)"
                    >
                      {{ $t("summer_trip.label_hotel") }} 1
                        <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('company_trip_employees.hotel_room')"
                        ></CIcon>
                       </span>
                    </th>
                    <th scope="col"
                      class="cl-pointer"
                      @click="sortByColumn(columnSortArr.hotel_room_1)"
                    >
                      {{ $t("summer_trip.label_hotel") }} 2
                        <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('company_trip_employees.hotel_room_1')"
                        ></CIcon>
                       </span>
                    </th>
                    <th scope="col"
                      class="cl-pointer"
                      @click="sortByColumn(columnSortArr.eatting_table)"
                    >
                      {{ $t("summer_trip.label_eatting_table") }}
                        <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('company_trip_employees.eatting_table')"
                        ></CIcon>
                       </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                <template v-for="(item, index) in listEmployeeSummerTrip">
                  <tr :key="index" v-if="isShowStaff">
                    <td>{{ item.employee_id  }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.company_name }}</td>
                    <td>{{ item.department_name }}</td>
                    <td>{{ item.job_title }}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>{{ item.team || '-' }}</td>
                    <td>{{ item.car_code }}</td>
                    <td>{{ item.car_code_1 }}</td>
                    <td>{{ item.flight_group }}</td>
                    <td>{{ item.hotel_room || '-' }}</td>
                    <td>{{ item.hotel_room_1 || '-' }}</td>
                    <td>{{ item.eatting_table || '-' }}</td>
                  </tr>
                  <template v-for="(guest, subIndex) in item.guest">
                      <tr :key="index + '-' + subIndex" class="guest_row" v-if="isShowGuest">
                        <td>{{ item.employee_id  }} </td>
                        <td>{{ item.name }}</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>{{ guest.name }}</td>
                        <td>{{ guest.relationship || $t('summer_trip.label_employee') }}</td>
                        <td>{{ guest.birthday }}</td>
                        <td>-</td>
                        <td>{{ guest.car_code }}</td>
                        <td>{{ guest.car_code_1 }}</td>
                        <td>{{ guest.flight_group }}</td>
                        <td>{{ guest.hotel_room || '-' }}</td>
                        <td>{{ guest.hotel_room_1 || '-' }}</td>
                        <td>{{ guest.eatting_table || '-' }}</td>
                      </tr>
                    </template>
                </template>
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <b-modal ref="flightDetailModal" v-b-modal="flightModalShow" :title="getFlightDetailModal">
      <template v-for="(flight, index) in flight_groups">
        <h5 :key="'team'+index">Đội {{ index }}</h5>
        <template v-for="(detail, subIndex) in (JSON.parse(flight.metadata) || [])">
          <CCard :key="'flight'+index+'-'+subIndex">
            <CCardHeader>
              <div class="d-flex flex-row flex-between">
                <div class="text-bold">{{detail.from}} - {{ detail.to }}</div>
                <div class="text-bold">{{ getDate(detail.takeoff_at) }} - {{ getDate(detail.landing_at) }}</div>
              </div>
            </CCardHeader>
            <CCardBody>
              <div class="d-flex flex-row flex-between">
                <div class="">{{ detail.brand }} - {{ detail.aircraft }}</div>
                <div class="text-bold">{{ getHour(detail.takeoff_at) }} - {{ getHour(detail.landing_at) }}</div>
              </div>
            </CCardBody>
          </CCard>
        </template>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from 'moment';
// import { number } from 'echarts/core';
export default {
  name: "CustomerIndex",
  metaInfo() {
    return {
      title: this.$t("summer_trip.label_title_page"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {
      listCustomers: [],
      isShowGuest: true,
      isShowStaff: true,
      flightModalShow: false,
      listTeams: [],
      listCarTeams: [],
      listFlightTeams: [],
      searchData: {
        team: 0,
        car: 0,
        flight: 0,
        eatting_table: 0,
        company: [],
        relative: [],
        itemsPerPage: 10,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0
        },
        columnSort: "company_trip_employees.employee_id",
        sortBy: "ASC",
      },
      columnSortArr: {
          id: "company_trip_employees.employee_id",
          name: "company_trip_employees.name",
          company_name: "companies.name",
          departments: "departments.name",
          group: "lucky_wheel_results.group",
          group_car: "company_trip_employees.car_code",
          group_car_1: "company_trip_employees.car_code_1",
          flight_group: "company_trip_employees.flight_group",
          hotel_room: "company_trip_employees.hotel_room",
          hotel_room_1: "company_trip_employees.hotel_room_1",
          eatting_table: "company_trip_employees.eatting_table"
      }
    };
  },
  computed: {
    ...mapGetters({
      listEmployeeSummerTrip: "summer-trip/listEmployeeSummerTrip",
      totalEmployee: "summer-trip/totalEmployee",
      totalRelationship: "summer-trip/totalRelationship",
      companies: "commons/companies",
      divisions: "commons/divisions",
      listItemsPerPage: "commons/listItemsPerPage",
      pagination: "summer-trip/pagination",
      flights: "summer-trip/flights",
      team_groups: "summer-trip/team_groups",
      car_groups: "summer-trip/car_groups",
      flight_groups: "summer-trip/flight_groups",
      groupSummerTrip: "summer-trip/groupSummerTrip",
      carSummerTrip: "summer-trip/carSummerTrip",
      flightSummerTrip: "summer-trip/flightSummerTrip",
      eatting_tables: "summer-trip/eatting_tables"
    }),
    relativeOptions() {

     return [
        {label: "Người thân", value: 1},
        {label: "Nhân viên", value: 0},
      ];
    },
    companiesOptions() {
      let options = [];
      for(let company in this.companies) {
        options.push({label: this.companies[company].name, value: company});
      }
      return options;
    },
    getFlightDetailModal() {
      return "Flight Detail"
    },
    total_participants() {
      var relativePeople = 0;
      this.listEmployeeSummerTrip.forEach(element => {
        relativePeople += element.guest?.length;
      });
      var total = relativePeople + this.listEmployeeSummerTrip.length;

      if(this.isShowGuest && this.isShowStaff){
        return total;
      }
      if(this.isShowGuest){
        return relativePeople;
      }
      return this.listEmployeeSummerTrip.length;
    },

  },
  methods: {
    ...mapActions("summer-trip", ["fetchEmployee", "fetchFlightDetail", "fetchSummerTripTeams", "fetchSummerTripForOverview"]),
    ...mapActions("commons", ["getCommonsData"]),

    async getListEmployeeSummerTrip() {
      await this.fetchEmployee({
        name: this.searchData.name,
        division: this.searchData.division,
        relative: this.searchData.relative,
        team: this.searchData.team,
        car:  this.searchData.car,
        flight:  this.searchData.flight,
        company: this.searchData.company,
        columnSort: this.searchData.columnSort,
        sortBy: this.searchData.sortBy,
        eatting_table: (this.searchData.eatting_table != null) ? this.searchData.eatting_table : "NULL"
      });
      this.searchData.paginate = this.pagination;
    },
    numberOfTeam(team){
      const res = this.groupSummerTrip.filter(item => item.group == team)
      return res[0]?.number ?? 0;
    },
    numberOfCar(car){
      const res = this.carSummerTrip.filter(item => item.car_code == car)
      return res[0]?.number ?? 0;
    },
    numberOfFlight(flight){
      const res = this.flightSummerTrip.filter(item => item.flight_group == flight)
      return res[0]?.number ?? 0;
    },

    updateField(fieldName, value) {
      this.searchData[fieldName] = value;
      this.search();
      // this.total_participants();
    },

    showGuest(value) {
      this.isShowGuest = false;
      this.isShowStaff = false;
      value.length && value.includes(0) && (this.isShowStaff = true);
      value.length && value.includes(1) && (this.isShowGuest = true);
      if (value.length == 0) {
        this.isShowGuest = true;
        this.isShowStaff = true;
      }
      this.searchData.relative = value;
      // this.total_participants();
    },

    search() {
      this.getListEmployeeSummerTrip();
    },

    async getCommons() {
      await this.getCommonsData();
      await this.fetchSummerTripTeams();
      await this.fetchSummerTripForOverview();
    },

    resetForm() {
      this.searchData.name = '';
      this.searchData.division = '';
      this.searchData.relative = '';
      this.getListEmployeeSummerTrip();
    },

    changePage(page) {
      this.getListEmployeeSummerTrip(this.searchData.itemsPerPage, page);
    },

    getSubIndex(index, subIndex) {
      return "subIndex_"+index+"_"+subIndex;
    },

    async showModal() {
      this.$refs["flightDetailModal"].show();
      // await this.getFlightDetail();
      // this.flightModalShow = true;
    },

    async getFlightDetail()
    {
      await this.fetchFlightDetail();
    },
    getDate(datetime) {
      return moment(datetime).format('ddd D/M');
    },
    getHour(datetime) {
      return moment(datetime).format('HH:mm');
    },
    classStatusSort(column) {
      return this.searchData.columnSort === column &&
        this.searchData.sortBy === "ASC"
        ? "sort-rotate"
        : "";
    },
    async sortByColumn(column) {
      if (this.searchData.columnSort != column) {
        this.searchData.sortBy = "DESC";
      }
      this.searchData.columnSort = column;
      this.searchData.sortBy =
        this.searchData.sortBy === "DESC" ? "ASC" : "DESC";
      // this.passParamUrl();
      console.log(this.searchData);
      await this.getListEmployeeSummerTrip();
    },
  },
  created() {
    this.getListEmployeeSummerTrip();
    this.getCommons();
  },
};
</script>

<style lang="scss" scoped>
.employee {
  margin: -2rem -30px 0 -30px;
  .card-table-emloyee {
    padding: 30px;
  }
  .btn-search-employee {
    background-color: #b5dbf2;
    padding: 8px;
    width: 120px;
  }
  .employee-table {
    margin: 24px 27px 0 30px;
  }
  .total-employee {
    background-color: #FFFFFF;
    margin: 0 27px 0 30px;
    border-radius: 5px;
    padding: 10px 20px;
    p {
      margin: 0;
      &:first-child {
        margin-bottom: 5px;
      }
      &>span {
        font-weight: bold;
      }
    }
  }
  .select-per-page {
    width: 70px;
  }
.guest-name {
  padding-left: 55px;
}
.no-padding {
  padding: 0px !important;
  & thead > tr > th {
    border-top: none;
  }
}
.margin-left-4 {
  margin-left: 4px;
}
.help {
  cursor: pointer;
}
.guest_row {
  background: #EFF2F7;
}
.text-center {
  text-align: center;
}
.card-summary {
  text-align: center;
}
.text-summary-member {
  font-size: 70px;
  font-weight: bold;
  color: #3488EB;
  &.primary {
    color: #FF5253;
  }
}

.text-summary-label {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  }
  .option-table {
    display: flex;
    justify-content: space-between;
  }
}
.d-flex {
  display: flex;
}
.flex-row {
  flex-direction: row;
}
.flex-between {
  justify-content: space-between;
}
.text-bold {
  font-weight: 700;
}
@media screen and (max-width: 767px) {
  .card-body {
    padding: 0 0.5rem;
  }
  .table-mobile {
    width: 900px;
    overflow-x: scroll;
  }
}
.cl-pointer {
  cursor: pointer;
  .icon-sort {
    margin-left: 5px;
    .c-icon {
      width: 12px;
    }
    .sort-rotate {
      transform: rotate(180deg);
    }
  }
}
.total-employee-summer-trip {
  margin: 0px 27px 0 30px;
  font-size: 16px;
  font-weight: 700;
}
.title-overview {
  height: 46px;
  font-weight: 700;
  font-size: 20px;
  line-height: 24.42px;
  letter-spacing: 0.07px;
  color: #2183DD;
  border: 1px solid #EFEFEF;
  border-radius: 10px;
  padding: 11px 0 11px 30px;
  width: 100%;
  background-color: #FFFFFF;
}
.card-overview {
  background-color: #E5E5E5;
  margin-bottom: 0px;
}
.team-player {
  height: 106px;
  letter-spacing: 0.07px;
  border: 1px solid #EFEFEF;
  border-radius: 10px;
  background-color: #FFFFFF;
  text-align: -webkit-center;
}
.card-line {
  border: 1px solid #E6E6E6;
  margin-left: 20.5px;
  margin-right: 20.5px;
}
.team-line {
  border: 1px solid #E6E6E6;
  margin-left: 14px;
  margin-right: 14px;
}
.team-player-number {
  font-weight: 700;
  font-size: 16px;
  line-height: 19.54px;
  letter-spacing: 0.07;
  color: #17A896;
}
.number-car {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.07;
  color: #303C54;
  font-style: normal;
}
.number-people-car {
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #17A896;;
}
.row-title {
  margin-left: 8px !important;
}
</style>
